export default "__VITE_ASSET__C2DwWHS4__"